import React from 'react';
import { currencyConfig } from '../../config/currency.config';
import i18n from '../../i18n';
import AmountInput from './components/AmountInput';

export default class DialogAmountField extends React.Component {
    render() {
        const { field, data } = this.props;
        const currencySymbol = data?.currency
            ? currencyConfig[data.currency]?.symbol ?? ''
            : '';

        return (
            <AmountInput
                id={field.id}
                label={i18n.t(`columns.${field.label}`)}
                fullWidth
                value={this.props.value}
                onChange={this.props.onChange}
                currencySymbol={currencySymbol}
            />
        );
    }
}
